import { j as a } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as h } from "../../../../IconBase-CxZyIWw2.js";
const i = r((s, e) => /* @__PURE__ */ a.jsx(
  h,
  {
    ref: e,
    ...s,
    image: (t) => /* @__PURE__ */ a.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...t,
        children: [
          /* @__PURE__ */ a.jsx(
            "mask",
            {
              id: "mask0_2974_3628",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ a.jsx(
                "path",
                {
                  fill: "#000",
                  d: "M8 16a2.513 2.513 0 0 1-2.514-2.514.69.69 0 0 1 .685-.686.69.69 0 0 1 .686.686 1.143 1.143 0 0 0 2.286 0V9.143h4.343a1.143 1.143 0 0 0 0-2.286H9.143V2.514a1.143 1.143 0 0 0-2.286 0v4.343H2.514a1.143 1.143 0 0 0 0 2.286h3.657a.69.69 0 0 1 .686.686.69.69 0 0 1-.686.685H2.514A2.513 2.513 0 0 1 0 8a2.513 2.513 0 0 1 2.514-2.514h2.972V2.514A2.513 2.513 0 0 1 8 0a2.513 2.513 0 0 1 2.514 2.514v2.972h2.972A2.513 2.513 0 0 1 16 8a2.513 2.513 0 0 1-2.514 2.514h-2.972v2.972A2.513 2.513 0 0 1 8 16"
                }
              )
            }
          ),
          /* @__PURE__ */ a.jsx("g", { mask: "url(#mask0_2974_3628)", children: /* @__PURE__ */ a.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyTreatmentIcon";
export {
  i as AgencyTreatmentIcon,
  i as default
};
//# sourceMappingURL=index.js.map
